import React from "react";

const QuestionCountSelector = props => {

  return (
    <table className="key-selector" valign="top" border="0">
      <thead><tr><th align="left">Questions</th></tr></thead>
      <tbody>
        <tr>
          <td> 
            <input 
              className="question-count-selector"
              type="number"
              min="5"
              max="50"
              step="1"
              value={props.questionCount}
              onChange={(event) => props.callbacks.questionCountSetter(event.target.value)}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );

};

export default QuestionCountSelector;
